var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-div"}},[_c('a-config-provider',{attrs:{"locale":_vm.locale}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }